


    <!-- Left Panel -->

    <aside id="left-panel" class="left-panel">
        <nav class="navbar navbar-expand-sm navbar-default">

            <div id="main-menu" class="main-menu collapse navbar-collapse">
                <ul class="nav navbar-nav" id="mnr">
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                        <a  routerLink="/ceo/dashboard" ><i class="menu-icon fa fa-dashboard"></i>CEO Dashboard </a>
                    </li>

                    <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                        <a  routerLink="/analyst/landingpage" ><i class="menu-icon fa fa-dashboard"></i>Home </a>
                    </li>

                    <li class="menu-item-has-children dropdown" id="uploadMenu" (click)="menuSubmenu('uploadMenu')">
                        <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="menu-icon fa fa-table"></i>Upload</a>
                        <ul class="sub-menu children dropdown-menu" id="subuploadMenu">
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a  routerLink="/analyst/fileupload" ><i class="menu-icon fa fa-file"></i>Upload File </a>
                            </li>
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a  routerLink="/analyst/flashUpload" ><i class="menu-icon fa fa-file"></i>Flash Upload</a>
                            </li>
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a  routerLink="/analyst/otherfileupload" ><i class="menu-icon fa fa-file"></i>Other File Upload</a>
                            </li>
                        </ul>
                    </li>

                    <li class="menu-item-has-children dropdown" id="viewMenu" (click)="menuSubmenu('viewMenu')">
                        <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="menu-icon fa fa-table"></i>View</a>
                        <ul class="sub-menu children dropdown-menu" id="subviewMenu">
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a routerLink="/analyst/viewfile" ><i class="menu-icon fa fa-eye"></i>View File </a>
                            </li>
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a  routerLink="/analyst/flashView" ><i class="menu-icon fa fa-file"></i>Flash View</a>
                            </li>
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a routerLink="/analyst/otherfilelist" ><i class="menu-icon fa fa-eye"></i>Other File View</a>
                            </li>
                        </ul>
                    </li>

                    <li class="menu-item-has-children dropdown" id="reportsMenu" (click)="menuSubmenu('reportsMenu')">
                        <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="menu-icon fa fa-table"></i>Reports</a>
                        <ul class="sub-menu children dropdown-menu" id="subreportsMenu">
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                 <a routerLink="/analyst/consoleReport"><i class="menu-icon fa fa-bar-chart"></i>Consolidated Report</a>
                            </li>
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a  routerLink="/analyst/flashReport" ><i class="menu-icon fa fa-file"></i>Flash Report</a>
                            </li>
                            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <a routerLink="/analyst/queryreport" ><i class="menu-icon fa fa-bar-chart"></i>Custom Report </a>
                            </li>
                        </ul>
                    </li>
                    
                    
                    
                    
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                        <a routerLink="/analyst/delrequest" ><i class="menu-icon fa fa-trash"></i>Delete Request </a>
                    </li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                        <a routerLink="/analyst/helpdoc" ><i class="menu-icon fa fa-question-circle"></i>Help Documents </a>
                    </li>
                    <!-- /.menu-title -->
                   <!--  <li class="menu-title">UI elements</li>
                    <li class="menu-item-has-children dropdown">
                        <a href="#" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="menu-icon fa fa-cogs"></i>Components</a>
                        <ul class="sub-menu children dropdown-menu">                            <li><i class="fa fa-puzzle-piece"></i><a href="ui-buttons.html">Buttons</a></li>
                            <li><i class="fa fa-id-badge"></i><a href="ui-badges.html">Badges</a></li>
                            <li><i class="fa fa-bars"></i><a href="ui-tabs.html">Tabs</a></li>

                            <li><i class="fa fa-id-card-o"></i><a href="ui-cards.html">Cards</a></li>
                            <li><i class="fa fa-exclamation-triangle"></i><a href="ui-alerts.html">Alerts</a></li>
                            <li><i class="fa fa-spinner"></i><a href="ui-progressbar.html">Progress Bars</a></li>
                            <li><i class="fa fa-fire"></i><a href="ui-modals.html">Modals</a></li>
                            <li><i class="fa fa-book"></i><a href="ui-switches.html">Switches</a></li>
                            <li><i class="fa fa-th"></i><a href="ui-grids.html">Grids</a></li>
                            <li><i class="fa fa-file-word-o"></i><a href="ui-typgraphy.html">Typography</a></li>
                        </ul>
                    </li>
                    <li class="menu-item-has-children active dropdown">
                        <a href="#" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="menu-icon fa fa-table"></i>Tables</a>
                        <ul class="sub-menu children dropdown-menu">
                            <li><i class="fa fa-table"></i><a href="tables-basic.html">Basic Table</a></li>
                            <li><i class="fa fa-table"></i><a href="tables-data.html">Data Table</a></li>
                        </ul>
                    </li>
                    <li class="menu-item-has-children dropdown">
                        <a href="#" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="menu-icon fa fa-th"></i>Forms</a>
                        <ul class="sub-menu children dropdown-menu">
                            <li><i class="menu-icon fa fa-th"></i><a href="forms-basic.html">Basic Form</a></li>
                            <li><i class="menu-icon fa fa-th"></i><a href="forms-advanced.html">Advanced Form</a></li>
                        </ul>
                    </li>

                    <li class="menu-title">Icons</li>

                    <li class="menu-item-has-children dropdown">
                        <a href="#" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="menu-icon fa fa-tasks"></i>Icons</a>
                        <ul class="sub-menu children dropdown-menu">
                            <li><i class="menu-icon fa fa-fort-awesome"></i><a href="font-fontawesome.html">Font Awesome</a></li>
                            <li><i class="menu-icon ti-themify-logo"></i><a href="font-themify.html">Themefy Icons</a></li>
                        </ul>
                    </li>
                    <li>
                        <a href="widgets.html"> <i class="menu-icon ti-email"></i>Widgets </a>
                    </li>
                    <li class="menu-item-has-children dropdown">
                        <a href="#" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="menu-icon fa fa-bar-chart"></i>Charts</a>
                        <ul class="sub-menu children dropdown-menu">
                            <li><i class="menu-icon fa fa-line-chart"></i><a href="charts-chartjs.html">Chart JS</a></li>
                            <li><i class="menu-icon fa fa-area-chart"></i><a href="charts-flot.html">Flot Chart</a></li>
                            <li><i class="menu-icon fa fa-pie-chart"></i><a href="charts-peity.html">Peity Chart</a></li>
                        </ul>
                    </li>

                    <li class="menu-item-has-children dropdown">
                        <a href="#" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="menu-icon fa fa-area-chart"></i>Maps</a>
                        <ul class="sub-menu children dropdown-menu">
                            <li><i class="menu-icon fa fa-map-o"></i><a href="maps-gmap.html">Google Maps</a></li>
                            <li><i class="menu-icon fa fa-street-view"></i><a href="maps-vector.html">Vector Maps</a></li>
                        </ul>
                    </li>
                    <li class="menu-title">Extras</li>
                    <li class="menu-item-has-children dropdown">
                        <a href="#" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="menu-icon fa fa-glass"></i>Pages</a>
                        <ul class="sub-menu children dropdown-menu">
                            <li><i class="menu-icon fa fa-sign-in"></i><a href="page-login.html">Login</a></li>
                            <li><i class="menu-icon fa fa-sign-in"></i><a href="page-register.html">Register</a></li>
                            <li><i class="menu-icon fa fa-paper-plane"></i><a href="pages-forget.html">Forget Pass</a></li>
                        </ul>
                    </li> -->
                </ul>
            </div><!-- /.navbar-collapse -->
        </nav>
    </aside><!-- /#left-panel -->
        <!-- Right Panel -->

    <div id="right-panel" class="right-panel">

        <!-- Header-->
        <header id="header" class="header">
            <div class="top-left">
                <div class="navbar-header">
                    <a class="navbar-brand" href="./"><img src="./assets/images/gic-header-logo.jpg" alt="Logo"></a>
                    <a class="navbar-brand hidden" href="./"><img src="./assets/images/logo2.png" alt="Logo"></a>
                    <a id="menuToggle" class="menutoggle" (click)="sideNavToggle()" ><i class="fa fa-bars"></i></a>
                </div>
            </div>
            <div class="top-right">
                <div class="header-menu">
                    <!--<div class="header-left">
                        <button class="search-trigger"><i class="fa fa-search"></i></button>
                        <div class="form-inline">
                            <form class="search-form">
                                <input class="form-control mr-sm-2" type="text" placeholder="Search ..." aria-label="Search">
                                <button class="search-close" type="submit"><i class="fa fa-close"></i></button>
                            </form>
                        </div>

                        <div class="dropdown for-notification">
                            <button class="btn btn-secondary dropdown-toggle" type="button" id="notification" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i class="fa fa-bell"></i>
                                <span class="count bg-danger">3</span>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="notification">
                                <p class="red">You have 3 Notification</p>
                                <a class="dropdown-item media" href="#">
                                    <i class="fa fa-check"></i>
                                    <p>Server #1 overloaded.</p>
                                </a>
                                <a class="dropdown-item media" href="#">
                                    <i class="fa fa-info"></i>
                                    <p>Server #2 overloaded.</p>
                                </a>
                                <a class="dropdown-item media" href="#">
                                    <i class="fa fa-warning"></i>
                                    <p>Server #3 overloaded.</p>
                                </a>
                            </div>
                        </div>

                        <div class="dropdown for-message">
                            <button class="btn btn-secondary dropdown-toggle" type="button" id="message" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i class="fa fa-envelope"></i>
                                <span class="count bg-primary">4</span>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="message">
                                <p class="red">You have 4 Mails</p>
                                <a class="dropdown-item media" href="#">
                                    <span class="photo media-left"><img alt="avatar" src="./assets/images/avatar/1.jpg"></span>
                                    <div class="message media-body">
                                        <span class="name float-left">Jonathan Smith</span>
                                        <span class="time float-right">Just now</span>
                                        <p>Hello, this is an example msg</p>
                                    </div>
                                </a>
                                <a class="dropdown-item media" href="#">
                                    <span class="photo media-left"><img alt="avatar" src="./assets/images/avatar/2.jpg"></span>
                                    <div class="message media-body">
                                        <span class="name float-left">Jack Sanders</span>
                                        <span class="time float-right">5 minutes ago</span>
                                        <p>Lorem ipsum dolor sit amet, consectetur</p>
                                    </div>
                                </a>
                                <a class="dropdown-item media" href="#">
                                    <span class="photo media-left"><img alt="avatar" src="./assets/images/avatar/3.jpg"></span>
                                    <div class="message media-body">
                                        <span class="name float-left">Cheryl Wheeler</span>
                                        <span class="time float-right">10 minutes ago</span>
                                        <p>Hello, this is an example msg</p>
                                    </div>
                                </a>
                                <a class="dropdown-item media" href="#">
                                    <span class="photo media-left"><img alt="avatar" src="./assets/images/avatar/4.jpg"></span>
                                    <div class="message media-body">
                                        <span class="name float-left">Rachel Santos</span>
                                        <span class="time float-right">15 minutes ago</span>
                                        <p>Lorem ipsum dolor sit amet, consectetur</p>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>-->
                    <div class="uarea">Hello, <br> {{userName}}</div>
                    <div class="user-area dropdown float-right" id="ddMenu">
                        <a  class="dropdown-toggle active" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" (click)="ddToggleMenu()" (blur)="ddToggleMenu()">
                           <!-- <img class="user-avatar rounded-circle" src="./assets/images/{{companyLogo}}" alt="User Avatar">-->
                           <img class="user-avatar rounded-circle" src="{{downLoadPath}}logo/{{companyLogo}}" alt="User Avatar">
                        </a>

                        <div class="user-menu dropdown-menu" id="ddLogout">
                            <a class="nav-link" href="#" (click)="glogout()"  ><i class="fa fa-power-off"></i>Logout</a>
                            <a class="nav-link" style="cursor: pointer;" (click)="gochgPsw()"  ><i class="fa fa-user"></i>Change Password</a>
                        </div>
                    </div>
                </div>
            </div>
        </header><!-- /header -->
        <!-- Header-->

       <!-- <div class="breadcrumbs">
            <div class="breadcrumbs-inner">
                <div class="row m-0">
                    <div class="col-sm-4">
                        <div class="page-header float-left">
                            <div class="page-title">
                                <h1>Dashboard</h1>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-8">
                        <div class="page-header float-right">
                            <div class="page-title">
                                <ol class="breadcrumb text-right">
                                    <li><a href="#">Dashboard</a></li>
                                    <li><a href="#">Table</a></li>
                                    <li class="active">Data table</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>-->

        <div class="content">
          <router-outlet></router-outlet>
        </div><!-- .content -->


        <div class="clearfix"></div>

        <footer class="site-footer">
            <div class="footer-inner bg-white">
                <div class="row">
                    <div class="col-sm-6">
                        Copyright &copy; 2020 General Insurance Council
                    </div>
                    <div class="col-sm-6 text-right">
                       Designed by Pentation Analytics Pvt. Ltd.
                    </div>
                </div>
            </div>
        </footer>

    </div><!-- /#right-panel -->

    <!-- Right Panel -->

   



